import { createBrowserRouter } from "react-router-dom";

import { FEATURES } from "./features";
import { AppShell } from "./layout/AppShell";
import { LoginPage } from "./login/LoginPage";
import { AuthProvider } from "./providers/AuthProvider";
import { RootErrorBoundary } from "./RootErrorBoundary";

import manualStyles from "@/features/manual/manual.module.css";

const featureRoutes = FEATURES.flatMap((feature) => feature.routes);

/**
 * The application router. /login is public — no auth gate, no AppShell.
 * All other routes are wrapped in AuthProvider so the session is available
 * throughout the app shell and every feature. The catch-all (*) surfaces
 * the RootErrorBoundary's "Page not found" view for unknown URLs.
 */
export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/",
    element: (
      <AuthProvider>
        <AppShell />
      </AuthProvider>
    ),
    errorElement: <RootErrorBoundary />,
    children: [
      ...featureRoutes,
      {
        path: "*",
        element: (
          <div className={manualStyles.view} role="alert">
            <div className={manualStyles.emptyState}>
              <strong>Page not found.</strong>
              <br />
              This page doesn&rsquo;t exist. Use the sidebar to navigate, or search OpsHub.
            </div>
          </div>
        ),
      },
    ],
  },
]);
